import { render } from "./bindEmail.vue?vue&type=template&id=d90da892&scoped=true"
import script from "./bindEmail.vue?vue&type=script&lang=js"
export * from "./bindEmail.vue?vue&type=script&lang=js"

import "./bindEmail.vue?vue&type=style&index=0&id=d90da892&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d90da892"]])

export default __exports__